// extracted by mini-css-extract-plugin
export var divider = "_jf-0";
export var systemMessage = "_jf-1";